export const FAVICON =
  "https://storage.googleapis.com/sciencespotlight-assets/SiteAssets/favicon.png";

// About Page
export const ABOUT_1 =
  "https://storage.googleapis.com/sciencespotlight-assets/SiteAssets/aboutpage.png";
export const ABOUT_MOBILE =
  "https://storage.googleapis.com/sciencespotlight-assets/SiteAssets/aboutpage.png";

// Home Page

export const CONFIRM =
  "https://storage.googleapis.com/sciencespotlight-assets/SiteAssets/confirmationpage.png";

export const CONFIRM_2 =
  "https://storage.googleapis.com/sciencespotlight-assets/SiteAssets/confirmationpage.png";

export const CONFIRM_MOBILE =
  "https://storage.googleapis.com/sciencespotlight-assets/SiteAssets/confirmationpage.png";

export const HOME_IMAGE =
  "https://storage.googleapis.com/sciencespotlight-assets/SiteAssets/homepage.png";

export const HOME_IMAGE_MOBILE =
  "https://storage.googleapis.com/sciencespotlight-assets/SiteAssets/homepage.png";

export const LOGO =
  "https://storage.googleapis.com/sciencespotlight-assets/Logo_TDA.png";

// Articles Page

export const COMING_SOON_IMAGE = "";

export const COMING_SOON_IMAGE_MOBILE = "";

export const COMING_SOON_BACKGROUND_IMAGE = "";
